import { useParams } from 'react-router'
import KpiSummary from '../stories/KpiSummary/KpiSummary'
import classes from './Matches.module.css'
import { useMatchStats, useSingleMatch } from './api'
import { Box, Center } from '@mantine/core'
import { Typography } from '../common/typography'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'
import Video from '../common/components/video/Video'

export default function WatchMatch() {
  const { competitionId, matchId } = useParams()
  const { data: match } = useSingleMatch({
    competition_id: Number(competitionId),
    match_id: Number(matchId),
  })
  const isDesktop = useMediaQuery('(min-width: 800px)')

  const src = match.video?.main

  // Fetch match stats data
  const { data: matchStats } = useMatchStats({
    competition_id: Number(competitionId),
    match_id: Number(matchId),
  })

  return (
    <div
      className={clsx(classes.match_summary_container, {
        [classes.match_summary_container_mobile]: !isDesktop,
      })}
    >
      <Box mb={20}>
        {src && <Video src={src} isMatch={true} />}
        {!src && <Center h={200}>No video available for this match.</Center>}
      </Box>
      <Typography
        level={2}
        fw={500}
        fs="lg"
        lh="125"
        fc={{ light: 'black', dark: 'gray-2' }}
      >
        Detailed Score Breakdown
      </Typography>
      {matchStats.kpi_stats.map((kpiStat) => (
        <KpiSummary
          key={kpiStat.metric_id}
          title={kpiStat.metric_name}
          home_team_percentage={kpiStat.home_team_percent * 100}
          home_team_score={kpiStat.home_team_score}
          away_team_percentage={kpiStat.away_team_percent * 100}
          away_team_score={kpiStat.away_team_score}
        />
      ))}
    </div>
  )
}
